<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<h2 class="h2a"><a id="page_vii"></a><a id="frontmatter01"></a>Acknowledgments</h2>
<p class="para">Thank you never seems like enough, but it will have to do.</p>
<p class="indent-para">Thank you to Deborah Schneider, my agent and friend.</p>
<p class="indent-para">Thank you to Kelley Ragland, Matt Martz, and Sarah Melnyk at St. Martin’s Press/Minotaur Books for your attention to detail and good humor while dealing with one not-so-detail-oriented author who looks and sounds suspiciously like me.</p>
<p class="indent-para">Thank you to my posse at NYU (in no particular order of importance; you can fight that one out among yourselves): Rosie Smith, Kathy Madden, Rajni Kannan, Caroline Sorlie, Crystal <a id="page_viii"></a>Jan, Joanne Staha (Nurse Joanne!), Norma Sparks, and Anna Pavlick. Wow—this bus ride is a long one and I can’t believe how much I’m enjoying it!</p>
<p class="indent-para">Thank you to my extended family and to my wonderful husband, Jim, and to my children who are rapidly becoming too old to call “children,” Dea and Patrick.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?b226285a